export default __webpack_public_path__ + "static/media/evolve.2ebf7542.svg";